import React, { ComponentType } from 'react';
import { useAiFunctions } from './useAiFunctions';

/**
 * Higher-Order Component that provides AI functions to class components
 * 
 * @param WrappedComponent - The component to wrap with AI functions
 * @returns A new component with AI functions passed as props
 */
export const withAiFunctions = <P extends object>(
  WrappedComponent: ComponentType<P & { aiFunctions?: ReturnType<typeof useAiFunctions> }>
) => {
  // Return a functional component
  const WithAiFunctionsComponent = (props: P) => {
    // Use the hook to get AI functions
    const aiFunctions = useAiFunctions();
    
    // Pass the AI functions as a prop to the wrapped component
    return <WrappedComponent {...props} aiFunctions={aiFunctions} />;
  };
  
  // Set display name for better debugging
  WithAiFunctionsComponent.displayName = `withAiFunctions(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;
  
  return WithAiFunctionsComponent;
};

export default withAiFunctions;
